import {Icon, IconProps} from '@chakra-ui/react';

export function XIcon(props: IconProps) {
  return (
    <Icon width="9px" height="9px" viewBox="0 0 9 9" fill="#FF005C" {...props}>
      <path d="M7.83139 2.50627C8.32467 2.01531 8.32561 1.21713 7.83349 0.725011C7.34137 0.232891 6.54319 0.23383 6.05223 0.727107L4.27933 2.50837L2.50643 0.727107C2.01547 0.23383 1.21729 0.232891 0.725174 0.725012C0.233054 1.21713 0.233993 2.01531 0.72727 2.50627L2.50853 4.27917L0.727271 6.05206C0.233993 6.54303 0.233054 7.3412 0.725174 7.83332C1.21729 8.32544 2.01547 8.3245 2.50643 7.83123L4.27933 6.04996L6.05223 7.83123C6.54319 8.3245 7.34137 8.32544 7.83349 7.83332C8.32561 7.3412 8.32467 6.54303 7.83139 6.05206L6.05013 4.27917L7.83139 2.50627Z" />
    </Icon>
  );
}
